// extracted by mini-css-extract-plugin
module.exports = {"when":"style_when__20z9YotdtdJ4uCx1oyY0QO"};